<template>
    <v-dialog v-model="getModalPrint.show" max-width="80%">
        <v-card color="#323639"
        dark>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="getModalPrint.show = false" float-right >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <iframe :src="getModalPrint.link"
                     width="100%" height="780" style="border: none;"></iframe>
            </v-card-text>
            
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getModalPrint'
            ])
        }
    }
</script>